import { Component, Input, OnInit } from '@angular/core';
import {  FormGroup } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { TakeSpareDetailComponent } from '../../../../facility/take-spare/take-spare-detail/take-spare-detail.component';
import { JobService } from '../../../../service/job.service';

@Component({
  selector: 'app-history-receive-record',
  templateUrl: './history-receive-record.component.html',
  styleUrls: ['./history-receive-record.component.less']
})
export class HistoryReceiveRecordComponent implements OnInit {
  @Input() jobId: any;
  validateForm: FormGroup | undefined;
  listOfData = [];
  loading = true;
  constructor(
    private modal: NzModalService,
    public message: NzMessageService,
    private jobService: JobService,
  ) {
  }


  ngOnInit(): void {
    this.queryStockData();
  }
  /**
   * 查询领料单记录数据
   *  @param flag 1表示点击搜索按钮，2表示翻页
   */
  async queryStockData() {

    const result = await this.jobService.getSpareListByJob(this.jobId);
    if (result == null) {
      this.loading = false;
      return;
    }
    this.listOfData = result;
    this.loading = false;
  }
  /**
   * 查询领料单详情
   * @param woNo 领料单编号
   */
  async DetailData(spareNo: string, permissionNo: string, desc: string, tflag: number) {
    const modals = this.modal.create({
      nzTitle: '领料单[' + spareNo + ']详情',
      nzContent: TakeSpareDetailComponent,
      nzStyle: { top: '20px' },
      nzWidth: 1000,
      nzFooter: null,
      nzMaskClosable: false,
      nzComponentParams: {
        takeSpareNo: spareNo,
        missionNo: permissionNo,
        description: desc,
        flag: tflag
      }
    });
  }
}
